import styled from 'styled-components';

export const DetailsWrapper = styled.div`
    padding: 10px;
    background-color: rgba(255,255,255,0.2);
`